import React from "react";
import PropTypes from "prop-types";
import Section from "../../common/Section";
import Col from "../../common/Col";
import TextInput from "../../common/TextInput";
import Button from "../../common/Button";
import RadioButtonGroup from "../../common/RadioButtonGroup";
import { AccountTypes } from "../../../constants/DomainConstants";

const SupportSpoVlaMedewerkerForm = (props) => {
    const {
        onAccountIdChange,
        onOrganisatieTypeChange,
        onSearch,
        accountId,
        organisatieType,
        error,
        validationMessageType
    } = props;

    function mapOnSearch(accountId, organisatieType) {
        return function () {
            return onSearch(accountId, organisatieType);
        };
    }

    return (
        <Section>
            <Col size={12}>
                <p style={({ margin: '1rem 0.5rem' })}>Als Sport Vlaanderen medewerker kan je de VTT toepassing openen names een organisator, sportfederatie/koepelorganisatie of gemeente.
                    <br />Op deze manier zie je exact dezelfde informatie als de organisatie die je wil assisteren.</p>
            </Col>

            <Col size={12}>
                <RadioButtonGroup
                    items={[{ value: AccountTypes.ORGANISATOR, label: "Organisator" }, { value: AccountTypes.FEDERATIE, label: "Federatie/Koepelorganisatie" }, { value: AccountTypes.GEMEENTE, label: "Gemeente" }]}
                    name="typeOrganisatie"
                    label="Type organisatie"
                    onChange={onOrganisatieTypeChange}
                    value={organisatieType}
                    horizontal
                />
            </Col>

            <Col size={12}>
                <TextInput
                    name="accountId"
                    label="Account ID"
                    value={accountId}
                    onChange={onAccountIdChange}
                    validationMessage={error ? error : null}
                    validationMessageType={validationMessageType}
                />
            </Col>

            <Col size={12}>
                <Button onClick={mapOnSearch(accountId, organisatieType)} text="Ga verder" style={({ marginLeft: 'auto', marginBottom: '1rem', marginRight: '0.5rem', display: 'block' })} />
            </Col>
        </Section>
    );
};

SupportSpoVlaMedewerkerForm.propTypes = {
    error: PropTypes.string,
    onAccountIdChange: PropTypes.func,
    onOrganisatieTypeChange: PropTypes.func,
    onSearch: PropTypes.func,
    accountId: PropTypes.string,
    organisatieType: PropTypes.string,
    validationMessageType: PropTypes.string
};

export default SupportSpoVlaMedewerkerForm;
